import { useSidebar } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

export function SidebarCollapseButton() {
    const { state, toggleSidebar } = useSidebar();
    const Icon = state === 'collapsed' ? ChevronsRight : ChevronsLeft;
    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={toggleSidebar}
            aria-label={state === 'collapsed' ? 'Развернуть сайдбар' : 'Свернуть сайдбар'}
        >
            <Icon strokeWidth={2.5} className="h-5 w-5 text-neutral-text-800" />
        </Button>
    );
}
